import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿El material es compatible con el programa de mi país?',
  answer: 'Biología en Acción™ incluye contenidos fundamentales de Biología para educación secundaria. El material puede seleccionarse y adaptarse al programa educativo de cada institución.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Una vez acreditado el pago, recibirás las instrucciones de acceso en el correo electrónico utilizado durante la compra. La entrega es completamente digital y no tiene costos de envío.'
}, {
  question: '¿Es editable?',
  answer: 'El material se entrega en formato PDF, listo para descargar, imprimir y utilizar. Puedes seleccionar las páginas y actividades que necesites para cada grupo.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. Tienes 7 días para revisar el material. Si consideras que no responde a tus necesidades, puedes solicitar la devolución dentro del periodo de garantía.'
}, {
  question: '¿Cuál es el precio y en qué moneda se cobra?',
  answer: 'El precio promocional es de USD 14.99 y corresponde a un único pago, sin suscripciones. Al ingresar al checkout, el importe se convertirá automáticamente a la moneda local disponible en tu país. Podrás revisar el monto final antes de confirmar la compra.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 md:py-20 px-4 bg-emerald-100/30" data-id="element-64">
      <div className="max-w-3xl mx-auto" data-id="element-65">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-black text-center text-slate-900 mb-6 md:mb-16" data-id="element-66">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-3" data-id="element-67">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-blue-100 overflow-hidden shadow-sm" data-id="element-68">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-5 md:p-6 text-left flex justify-between items-center gap-4" data-id="element-69">
                <span className="font-black text-slate-900 text-sm md:text-lg leading-tight" data-id="element-70">
                  {faq.question}
                </span>
                <div className="shrink-0 text-emerald-600" data-id="element-71">
                  {openIndex === index ? <Minus size={20} data-id="element-72" /> : <Plus size={20} data-id="element-73" />}
                </div>
              </button>

              <AnimatePresence data-id="element-74">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-75">
                    <div className="px-5 md:px-6 pb-6 text-slate-600 font-medium text-xs md:text-base leading-relaxed" data-id="element-76">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}